module.exports = __webpack_public_path__ + "066f672c7e202a03e15cbe799575eb95.pdf";